import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';

import { API as baseURL } from '^configs/environments';

const createClient = (config?: AxiosRequestConfig): AxiosInstance => axios.create({
  baseURL,
  ...config,
});

export const apiClient = createClient();
